import { convertDigitToProperFormat } from '../../utils/number';
import i18n from '../../i18n';

export default {
  guides: 'آموزش‌ها',
  searchHere: 'اینجا جستجو کن',
  errorOnFetch: 'خطایی رخ داده است. مجدداْ سعی کنید',
  loading: 'در حال بارگذاری ... ',
  all: 'همه',
  relatedGuideCount(count: number) {
    const formatedCount = convertDigitToProperFormat(count) as any;
    return i18n.t('relatedGuideCount', {
      ns: 'general',
      count: formatedCount,
    });
  },
  relatedTabButton(count: number) {
    const formatedCount = convertDigitToProperFormat(count) as any;
    return i18n.t('relatedTabButton', {
      ns: 'general',
      count: formatedCount,
    });
  },
};
